import { staticUrl } from '@/utils/u7buy';
import coinsw from 'assets/images-new/icon/coins-w.webp';
import coinsb from 'assets/images-new/icon/coins-b.webp';
import playersw from 'assets/images-new/icon/players-w.webp';
import playersb from 'assets/images-new/icon/players-b.webp';
import squadw from 'assets/images-new/icon/squad-w.webp';
import squadb from 'assets/images-new/icon/squad-b.webp';
import boostingw from 'assets/images-new/icon/boosting-w.webp';
import boostingb from 'assets/images-new/icon/boosting-b.webp';
import { i18n } from '@/locales/index';
export interface FcTab {
  imgUrl: string;
  imgUrlBlack: string;
  name: string;
  url: string;
}

export const tabList = computed((): FcTab[] => {
  return [
    {
      imgUrl: coinsw,
      imgUrlBlack: coinsb,
      name: i18n.global.t('fc25.tabCoins'),
      url: '/fc25/fc25-coins'
    },
    {
      imgUrl: playersw,
      imgUrlBlack: playersb,
      name: i18n.global.t('fc25.tabPlayers'),
      url: '/fc25/fc25-players'
    },
    {
      imgUrl: boostingw,
      imgUrlBlack: boostingb,
      name: i18n.global.t('fc25.FC25Boosting'),
      url: '/fc25/fc25-boosting'
    },
    {
      imgUrl: squadw,
      imgUrlBlack: squadb,
      name: i18n.global.t('fc25.FC25Squad'),
      url: '/fc25/fc25-squad'
    }
  ];
});

export const tabListUpgrade = computed((): FcTab[] => {
  return [
    {
      imgUrl: coinsw,
      imgUrlBlack: coinsb,
      name: i18n.global.t('fc25.tabCoins'),
      url: '/fc26/fc26-coins'
    },
    {
      imgUrl: playersw,
      imgUrlBlack: playersb,
      name: i18n.global.t('fc25.tabPlayers'),
      url: '/fc26/fc26-players'
    },
    {
      imgUrl: boostingw,
      imgUrlBlack: boostingb,
      name: i18n.global.t('fc25.FC25Boosting'),
      url: '/fc26/fc26-boosting'
    },
    {
      imgUrl: squadw,
      imgUrlBlack: squadb,
      name: i18n.global.t('fc25.FC25Squad'),
      url: '/fc26/fc26-squad'
    },
    {
      imgUrl: `${staticUrl}/assets/images-new/icon/game-point-w.webp`,
      imgUrlBlack: `${staticUrl}/assets/images-new/icon/game-point-b.webp`,
      name: 'Points',
      url: '/fc26/points'
    },
    {
      imgUrl: `${staticUrl}/assets/images-new/icon/video-games-w.webp`,
      imgUrlBlack: `${staticUrl}/assets/images-new/icon/video-games-b.webp`,
      name: i18n.global.t('home.videoGames'),
      url: '/fc26/key'
    }
  ];
});

export const platformArr = [
  {
    label: 'PS4/PS5',
    value: '1888074725990690819'
  },
  {
    label: 'XBox one/series',
    value: '1888074726057799682'
  },
  {
    label: 'PC',
    value: '1888074725990690847'
  }
];

export const businessObj = {
  gameService: {
    all: [
      '1820693954263351300',
      '1820693954263351301',
      '1820693954263351302',
      '1820693954263351303',
      '1820693954263351304',
      '1820693954263351305'
    ],
    coins: {
      id: '1820693954263351300',
      name: '金币'
    },
    items: {
      id: '1820693954263351301',
      name: '装备'
    },
    accounts: {
      id: '1820693954263351302',
      name: '账号'
    },
    coaching: {
      id: '1820693954263351303',
      name: '陪玩'
    },
    boosting: {
      id: '1820693954263351304',
      name: '代练'
    },
    topup: {
      id: '1820693954263351305',
      name: '直充'
    }
  },
  digitalGoods: {
    all: ['1820693954263351306', '1820693954263351307', '1820693954263351308', '1820693954263351309', '1820693954263351310'],
    gamePoints: {
      id: '1820693954263351306',
      name: '游戏点数'
    },
    giftCards: {
      id: '1820693954263351307',
      name: '礼品卡'
    },
    subscriptions: {
      id: '1820693954263351308',
      name: '订阅'
    },
    software: {
      id: '1820693954263351309',
      name: '软件'
    },
    videoGames: {
      id: '1820693954263351310',
      name: '主机游戏'
    }
  },
  fifa: {
    all: ['1848553943624232961', '1848554129733890049', '1876446768564609026', '1848554356402466818', '1848554567304654850'],
    fifaCoins: {
      id: '1848553943624232961',
      name: 'fifa金币'
    },
    fifaPlayer: {
      id: '1848554129733890049',
      name: 'fifa球员'
    },
    fifaSquad: {
      id: '1876446768564609026',
      name: 'fifa squad'
    },
    fifaSBC: {
      id: '1848554356402466818',
      name: 'fifa SBC'
    },
    fifaUltimateTeam: {
      id: '1848554567304654850',
      name: 'fifa 球队'
    }
  }
};

// 上传/编辑offer发货时间的枚举值
export const offerDeliveryTimeOptions = [
  {
    label: '10 mins',
    value: '10'
  },
  {
    label: '30 mins',
    value: '30'
  },
  {
    label: '1 hour',
    value: '60'
  },
  {
    label: '2 hours',
    value: '120'
  },
  {
    label: '3 hours',
    value: '180'
  },
  {
    label: '5 hours',
    value: '300'
  },
  {
    label: '8 hours',
    value: '480'
  },
  {
    label: '12 hours',
    value: '720'
  },
  {
    label: '18 hours',
    value: '1080'
  },
  {
    label: '24 hours',
    value: '1440'
  },
  {
    label: '3 days',
    value: '4320'
  },
  {
    label: '5 days',
    value: '7200'
  },
  {
    label: '8 days',
    value: '11520'
  },
  {
    label: '10 days',
    value: '14400'
  },
  {
    label: '15 days',
    value: '21600'
  }
];
